import './scripts/common';
import './scripts/common-nav';

let _config = window['_config'] || {};
import {translate} from '@elements/translations';
import {findIn, find} from '@elements/dom-utils';
import * as reloadForm from "@elements/reload-form";
reloadForm.init();



// Todo: Add page specific JS here e.g:
import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass:"icon icon-chevron-right",
    dots: false,
    arrowRenderFunction: arrowRenderFunction,
}, {
    base: '.js-scroll-slider',
    area: '.js-scroll-slider__area',
    item: '.js-scroll-slider__item',
});

function arrowRenderFunction(container, direction, disabled, options) {
    let markupElement = document.createElement('div'),
        arrowMarkup = `<button type="button" class="${options.arrowClass} ${direction === 0 ? options.arrowPrevClass : options.arrowNextClass}" ${disabled ? 'disabled' : ''}><span class="scroll-slider__arrow-icon icon icon-chevron ${direction === 0 ? 'icon-rotate-90' :  'icon-rotate-270' }" aria-label="${translate('scroll-slider-'+ direction + '')}" title="${translate('scroll-slider-'+ direction + '')}"></span></button>`;
    markupElement.innerHTML = arrowMarkup;
    let newArrow = markupElement.childNodes[0];
    let arrowContainer = findIn('.js-scroll-slider__arrow-wrapper', container);
    arrowContainer.appendChild(newArrow);
    return newArrow;
}

import * as formValidation from '@elements/form-validation';
formValidation.init();